(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8510],{

/***/ 26308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContactForm; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Alert/Alert.tsx + 1 modules
var Alert = __webpack_require__(60585);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/contact.service.ts
var contact_service = __webpack_require__(20644);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/ContactForm/ContactForm.elements.tsx



var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Background",
  componentId: "sc-y2oqks-0"
})(["background:", ";margin-bottom:", ";"], function (props) {
  return props.withoutBackground ? props.theme.colors.white : props.theme.colors.darkLight;
}, (0,polished_esm/* rem */.hO)(240));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Wrapper",
  componentId: "sc-y2oqks-1"
})(["padding:", ";margin-top:", ";display:flex;flex-direction:column;align-items:center;@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(20));
var Form = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Form",
  componentId: "sc-y2oqks-2"
})(["background:", ";padding:", ";border-radius:", ";margin-bottom:", ";box-shadow:0 5px 10px 0 rgba(0,0,0,0.15);"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(-200));
var FormFieldsStyles = (0,styled_components_browser_esm/* css */.iv)(["width:100%;padding:", ";margin-bottom:", ";border:1px solid ", ";border-radius:", ";display:block;&.error{margin-bottom:0;border-color:", ";}@media (min-width:", "px){width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(8), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.danger;
}, theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(700));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "ContactFormelements__Input",
  componentId: "sc-y2oqks-3"
})(["", " height:", ";"], FormFieldsStyles, (0,polished_esm/* rem */.hO)(50));
var TextArea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
  displayName: "ContactFormelements__TextArea",
  componentId: "sc-y2oqks-4"
})(["", " height:", ";"], FormFieldsStyles, (0,polished_esm/* rem */.hO)(150));
var ErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__ErrorMessage",
  componentId: "sc-y2oqks-5"
})(["margin:", " 0 ", " 0;display:block;font-size:", ";color:", ";"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.textBase;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.danger;
});
var GlobalErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__GlobalErrorMessage",
  componentId: "sc-y2oqks-6"
})(["color:", ";padding-top:", ";margin-bottom:-", ";display:block;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.danger;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(10));
var SuccessMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__SuccessMessage",
  componentId: "sc-y2oqks-7"
})(["color:", ";padding-top:", ";display:block;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.green;
}, (0,polished_esm/* rem */.hO)(20));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ContactForm/ContactForm.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ContactFormTemplate = function ContactFormTemplate(_ref) {
  var withoutBackground = _ref.withoutBackground;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();
  var nameInputRef = (0,react.useRef)();
  var emailInputRef = (0,react.useRef)();
  var phoneInputRef = (0,react.useRef)();
  var messageInputRef = (0,react.useRef)();

  var _useState = (0,react.useState)(false),
      hasNameError = _useState[0],
      setHasNameError = _useState[1];

  var _useState2 = (0,react.useState)(false),
      hasEmailError = _useState2[0],
      setHasEmailError = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      hasMessageError = _useState3[0],
      setMessageError = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      hasSentError = _useState4[0],
      setHasSentError = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isLoading = _useState5[0],
      setIsLoading = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isSent = _useState6[0],
      setIsSent = _useState6[1];

  var _useState7 = (0,react.useState)(null),
      token = _useState7[0],
      setToken = _useState7[1];

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _nameInputRef$current, _emailInputRef$curren, _emailInputRef$curren2, _messageInputRef$curr;

      var hasError, _nameInputRef$current2, _nameInputRef$current3, _emailInputRef$curren3, _phoneInputRef$curren, _phoneInputRef$curren2, _messageInputRef$curr2, _window, _window$fbq, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setHasNameError(false);
              setHasEmailError(false);
              setMessageError(false);
              setHasSentError(false);
              setIsSent(false);
              hasError = false;

              if (!((nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current = nameInputRef.current) === null || _nameInputRef$current === void 0 ? void 0 : _nameInputRef$current.value) === '')) {
                _context.next = 9;
                break;
              }

              setHasNameError(true);
              return _context.abrupt("return");

            case 9:
              if (!((emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren = emailInputRef.current) === null || _emailInputRef$curren === void 0 ? void 0 : _emailInputRef$curren.value) === '' || !constants/* EMAIL_REGEX.test */.CU.test(emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren2 = emailInputRef.current) === null || _emailInputRef$curren2 === void 0 ? void 0 : _emailInputRef$curren2.value))) {
                _context.next = 12;
                break;
              }

              setHasEmailError(true);
              return _context.abrupt("return");

            case 12:
              if (!((messageInputRef === null || messageInputRef === void 0 ? void 0 : (_messageInputRef$curr = messageInputRef.current) === null || _messageInputRef$curr === void 0 ? void 0 : _messageInputRef$curr.value) === '')) {
                _context.next = 15;
                break;
              }

              setMessageError(true);
              return _context.abrupt("return");

            case 15:
              if (!hasError) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return");

            case 17:
              _context.prev = 17;
              setIsLoading(true);
              data = _objectSpread(_objectSpread(_objectSpread({}, (nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current2 = nameInputRef.current) === null || _nameInputRef$current2 === void 0 ? void 0 : _nameInputRef$current2.value) && {
                name: nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current3 = nameInputRef.current) === null || _nameInputRef$current3 === void 0 ? void 0 : _nameInputRef$current3.value
              }), {}, {
                email: emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren3 = emailInputRef.current) === null || _emailInputRef$curren3 === void 0 ? void 0 : _emailInputRef$curren3.value
              }, (phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren = phoneInputRef.current) === null || _phoneInputRef$curren === void 0 ? void 0 : _phoneInputRef$curren.value) && {
                phone: phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren2 = phoneInputRef.current) === null || _phoneInputRef$curren2 === void 0 ? void 0 : _phoneInputRef$curren2.value
              }), {}, {
                message: messageInputRef === null || messageInputRef === void 0 ? void 0 : (_messageInputRef$curr2 = messageInputRef.current) === null || _messageInputRef$curr2 === void 0 ? void 0 : _messageInputRef$curr2.value,
                token: token
              });
              (_window = window) === null || _window === void 0 ? void 0 : (_window$fbq = _window.fbq) === null || _window$fbq === void 0 ? void 0 : _window$fbq.call(_window, 'track', router.pathname.includes(constants/* ROUTES.CLASSROOM_RENT */.Z6.CLASSROOM_RENT) ? constants/* FBQ_EVENTS.LEAD */.PT.LEAD : constants/* FBQ_EVENTS.CONTACT */.PT.CONTACT);

              if (!router.pathname.includes(constants/* ROUTES.CLASSROOM_RENT */.Z6.CLASSROOM_RENT)) {
                _context.next = 26;
                break;
              }

              _context.next = 24;
              return contact_service/* contactApi.contactLease */.e.contactLease(data);

            case 24:
              _context.next = 28;
              break;

            case 26:
              _context.next = 28;
              return contact_service/* contactApi.contact */.e.contact(data);

            case 28:
              setIsSent(true);
              setIsLoading(false);
              emailInputRef.current.value = '';
              nameInputRef.current.value = '';
              phoneInputRef.current.value = '';
              messageInputRef.current.value = '';
              _context.next = 39;
              break;

            case 36:
              _context.prev = 36;
              _context.t0 = _context["catch"](17);
              setHasSentError(true);

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 36]]);
    }));

    return function handleClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  var verifyRecaptchaCallback = (0,react.useCallback)(function (token) {
    setToken(token);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Background, {
    withoutBackground: withoutBackground,
    children: [hasSentError && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
      type: Alert/* AlertTypes.error */.d.error,
      message: t('contact.error')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
            tagType: Title/* TitleTagTypes.H3 */.Z.H3,
            alignLeft: true,
            isBlack: true,
            children: t('contact.contact.title')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: nameInputRef,
            placeholder: t('contact.form.name.placeholder'),
            className: "".concat(hasNameError ? 'error' : '')
          }), hasNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.name.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: emailInputRef,
            placeholder: t('contact.form.email.placeholder'),
            className: "".concat(hasEmailError ? 'error' : '')
          }), hasEmailError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.email.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: phoneInputRef,
            placeholder: t('contact.form.phone.placeholder')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextArea, {
            ref: messageInputRef,
            placeholder: t('contact.form.message.placeholder'),
            className: "".concat(hasMessageError ? 'error' : '')
          }), hasMessageError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.message.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptcha */.mP, {
            onVerify: verifyRecaptchaCallback
          }), (hasNameError || hasEmailError || hasMessageError) && /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalErrorMessage, {
            children: t('contact.form.error')
          }), !isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            isLoading: isLoading,
            marginTop: 30,
            onClick: handleClick,
            text: "Odeslat"
          }), isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessMessage, {
            children: t('contact.form.sent')
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var ContactForm = (ContactFormTemplate);

/***/ }),

/***/ 59922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40238);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49642);





var useScrollToSection = function useScrollToSection(sectionNameInPathname, sectionIdInHtml) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (router.asPath.includes(sectionNameInPathname)) {
      var element = document.getElementById(sectionIdInHtml);
      return window.scrollTo({
        top: element.offsetTop - (window.innerWidth > _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.sm */ .A.sm ? _constants__WEBPACK_IMPORTED_MODULE_2__/* .DESKTOP_HEADER_HEIGHT */ .cf : _constants__WEBPACK_IMPORTED_MODULE_2__/* .MOBILE_HEADER_HEIGHT */ .ZQ),
        behavior: 'smooth'
      });
    }
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useScrollToSection);

/***/ }),

/***/ 82567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ kontakt; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Address/Address.elements.tsx




var Contact = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Addresselements__Contact",
  componentId: "sc-1gtfro9-0"
})(["padding:", " 0;@media (min-width:", "px){display:flex;align-items:flex-start;}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md);
var Company = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Addresselements__Company",
  componentId: "sc-1gtfro9-1"
})(["padding:0 ", " ", " 0;@media (min-width:", "px){min-width:35%;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md);
var Transportation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Addresselements__Transportation",
  componentId: "sc-1gtfro9-2"
})(["display:flex;flex-direction:column;margin-top:", ";padding:", " 0;@media (min-width:", "px){flex-direction:row;justify-content:space-between;}@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(35), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md, theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(10));
var TransportationOptions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Addresselements__TransportationOptions",
  componentId: "sc-1gtfro9-3"
})(["width:100%;padding:", " 0;@media (min-width:", "px){width:65%;}@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md, theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(10));
var TransportationOption = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Addresselements__TransportationOption",
  componentId: "sc-1gtfro9-4"
})([""]);
var TransportationHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Addresselements__TransportationHeader",
  componentId: "sc-1gtfro9-5"
})(["display:flex;flex-direction:row;justify-content:space-between;padding:", " 0;border-bottom:1px solid ", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(20), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
});
var TransportationHeaderTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Addresselements__TransportationHeaderTitle",
  componentId: "sc-1gtfro9-6"
})(["font-size:", ";"], (0,polished_esm/* rem */.hO)(18));
var TransportationHeaderIcon = (0,styled_components_browser_esm/* default */.ZP)(IconTemplate/* IconTemplate */._).withConfig({
  displayName: "Addresselements__TransportationHeaderIcon",
  componentId: "sc-1gtfro9-7"
})(["svg{width:", ";height:", ";}&.isOpen{svg{transform:rotate(180deg);}}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20));
var TransportationDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Addresselements__TransportationDescription",
  componentId: "sc-1gtfro9-8"
})(["padding-top:", " 0;"], (0,polished_esm/* rem */.hO)(10));
var CompanyLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Addresselements__CompanyLabel",
  componentId: "sc-1gtfro9-9"
})(["display:block;padding-bottom:", ";", ";", ";", ";"], (0,polished_esm/* rem */.hO)(5), function (prop) {
  return prop.marginTop ? "margin-top: ".concat((0,polished_esm/* rem */.hO)(prop.marginTop)) : '';
}, function (prop) {
  return prop.isBold ? "font-weight: ".concat(prop.theme.fontWeights.textBold) : '';
}, function (prop) {
  return prop.isBold ? "font-size: ".concat(prop.theme.fontSizes.h6) : '';
});
var CompanyLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Addresselements__CompanyLink",
  componentId: "sc-1gtfro9-10"
})(["display:block;padding-bottom:", ";font-size:", ";text-decoration:underline;color:", ";cursor:pointer;margin-top:", ";"], (0,polished_esm/* rem */.hO)(8), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.textBase;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(2));
var Map = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Addresselements__Map",
  componentId: "sc-1gtfro9-11"
})(["width:100%;iframe{border-radius:", ";@media (min-width:", "px){min-height:", ";}}"], (0,polished_esm/* rem */.hO)(16), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(500));
var ContactMap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Addresselements__ContactMap",
  componentId: "sc-1gtfro9-12"
})([""]);
// EXTERNAL MODULE: ./src/hooks/useScrollToSection.ts
var useScrollToSection = __webpack_require__(59922);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Address/Address.tsx









var TRANSPORTATION_OPTIONS;

(function (TRANSPORTATION_OPTIONS) {
  TRANSPORTATION_OPTIONS["TRAM"] = "tram";
  TRANSPORTATION_OPTIONS["METRO"] = "metro";
  TRANSPORTATION_OPTIONS["BUS"] = "bus";
  TRANSPORTATION_OPTIONS["TRAIN"] = "train";
  TRANSPORTATION_OPTIONS["CAR"] = "car";
})(TRANSPORTATION_OPTIONS || (TRANSPORTATION_OPTIONS = {}));

var AddressTemplate = function AddressTemplate() {
  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)([]),
      openedTransportationOptions = _useState[0],
      setOpenedTransportationOptions = _useState[1];

  (0,useScrollToSection/* default */.Z)('kde-nas-najdete', 'kdenasnajdete');

  var toggleTransportationOption = function toggleTransportationOption(option) {
    openedTransportationOptions.includes(option) ? setOpenedTransportationOptions([]) : setOpenedTransportationOptions([option]);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    withPadding: true,
    mobileSidePadding: 20,
    id: "kdenasnajdete",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H2 */.Z.H2,
      isBlack: true,
      children: t('contact.company.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Contact, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Company, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          isBold: true,
          children: "U\u010Debny Studio W"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          marginTop: 10,
          children: "Karlovo n\xE1m\u011Bst\xED 3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          children: "120 00 Praha 2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLink, {
          target: "_blank",
          href: "https://maps.app.goo.gl/w4en6jh3rwZjWEy37",
          children: "Zobrazit na map\u011B"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          marginTop: 10,
          children: "Novotn\xE9ho l\xE1vka 5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          children: "110 00 Praha 1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLink, {
          target: "_blank",
          href: "https://maps.app.goo.gl/qNG83N7QKmQknuFF6",
          children: "Zobrazit na map\u011B"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Company, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          isBold: true,
          children: "Studio W kancel\xE1\u0159"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          marginTop: 10,
          children: "Novotn\xE9ho l\xE1vka 5"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          children: "110 00 Praha 1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLink, {
          target: "_blank",
          href: "https://maps.app.goo.gl/qNG83N7QKmQknuFF6",
          children: "Zobrazit na map\u011B"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Company, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          isBold: true,
          children: "Faktura\u010Dn\xED \xFAdaje"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          marginTop: 10,
          children: "Poradce Podnikatele, spol. s r.o."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          children: "Jablonsk\xE9ho 639/4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          children: "170 00 Praha 7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          marginTop: 10,
          children: "I\u010CO: 49678876"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          children: "DI\u010C: CZ49678876"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          children: "\u010C. \xFA\u010Dtu: 151361399/0600"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          children: "IBAN: CZ7206000000000151361399"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLabel, {
          children: "MONETA Money Bank, a.s."
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Transportation, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        tagType: Title/* TitleTagTypes.H3 */.Z.H3,
        alignLeft: true,
        isBlack: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          dangerouslySetInnerHTML: {
            __html: t('contact.transportation.title')
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationOptions, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationOption, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationHeader, {
            onClick: function onClick() {
              return toggleTransportationOption(TRANSPORTATION_OPTIONS.TRAM);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderTitle, {
              children: t('contact.transportation.tram.label')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderIcon, {
              className: openedTransportationOptions.includes(TRANSPORTATION_OPTIONS.TRAM) ? 'isOpen' : 'isClose',
              name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
            })]
          }), openedTransportationOptions.includes(TRANSPORTATION_OPTIONS.TRAM) && /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationDescription, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              dangerouslySetInnerHTML: {
                __html: t('contact.transportation.tram.description')
              }
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationOption, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationHeader, {
            onClick: function onClick() {
              return toggleTransportationOption(TRANSPORTATION_OPTIONS.METRO);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderTitle, {
              children: t('contact.transportation.metro.label')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderIcon, {
              className: openedTransportationOptions.includes(TRANSPORTATION_OPTIONS.METRO) ? 'isOpen' : 'isClose',
              name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
            })]
          }), openedTransportationOptions.includes(TRANSPORTATION_OPTIONS.METRO) && /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationDescription, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              dangerouslySetInnerHTML: {
                __html: t('contact.transportation.metro.description')
              }
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationOption, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationHeader, {
            onClick: function onClick() {
              return toggleTransportationOption(TRANSPORTATION_OPTIONS.TRAIN);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderTitle, {
              children: t('contact.transportation.train.label')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderIcon, {
              className: openedTransportationOptions.includes(TRANSPORTATION_OPTIONS.TRAIN) ? 'isOpen' : 'isClose',
              name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
            })]
          }), openedTransportationOptions.includes(TRANSPORTATION_OPTIONS.TRAIN) && /*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationDescription, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              dangerouslySetInnerHTML: {
                __html: t('contact.transportation.train.description1')
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              dangerouslySetInnerHTML: {
                __html: t('contact.transportation.train.description2')
              }
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationOption, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationHeader, {
            onClick: function onClick() {
              return toggleTransportationOption(TRANSPORTATION_OPTIONS.CAR);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderTitle, {
              children: t('contact.transportation.car.label')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderIcon, {
              className: openedTransportationOptions.includes(TRANSPORTATION_OPTIONS.CAR) ? 'isOpen' : 'isClose',
              name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
            })]
          }), openedTransportationOptions.includes(TRANSPORTATION_OPTIONS.CAR) && /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationDescription, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              dangerouslySetInnerHTML: {
                __html: t('contact.transportation.car.description1')
              }
            })
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ var Address = (AddressTemplate);
// EXTERNAL MODULE: ./src/components/ContactForm/ContactForm.tsx + 1 modules
var ContactForm = __webpack_require__(26308);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
;// CONCATENATED MODULE: ./src/components/ContactHero/Hero.elements.tsx





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Wrapper",
  componentId: "sc-m3tb3j-0"
})(["display:flex;padding:", " ", ";max-width:", ";margin:", " auto 0 auto;min-height:", ";flex-direction:column-reverse;@media (min-width:", "px){margin:", " auto 0 auto;}@media (min-width:", "px){flex-direction:row;align-items:center;padding:0;}"], (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(500), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), theme/* breakpoints.md */.A.md);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Heroelements__Image",
  componentId: "sc-m3tb3j-1"
})(["width:100%;border-radius:", ";height:auto;margin-top:", ";@media (min-width:", "px){display:block;margin-top:", ";width:", ";}"], (0,polished_esm/* rem */.hO)(24), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(600));
var Hero_elements_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Heroelements__Title",
  componentId: "sc-m3tb3j-2"
})(["font-weight:", ";font-size:", ";font-family:", ";padding-bottom:", ";@media (min-width:", "px){font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h3;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h2;
});
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Item",
  componentId: "sc-m3tb3j-3"
})(["display:flex;padding:", " 0;"], (0,polished_esm/* rem */.hO)(20));
var Contacts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Contacts",
  componentId: "sc-m3tb3j-4"
})(["display:flex;flex-direction:column;justify-content:center;@media (min-width:", "px){padding-left:", ";}"], theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(50));
var Hero_elements_Icon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Heroelements__Icon",
  componentId: "sc-m3tb3j-5"
})(["padding-right:", ";svg{width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(35), (0,polished_esm/* rem */.hO)(35));
var Hero_elements_Contact = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Contact",
  componentId: "sc-m3tb3j-6"
})(["display:flex;flex-direction:column;font-size:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h6;
});
var ContactTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__ContactTitle",
  componentId: "sc-m3tb3j-7"
})(["font-weight:", ";padding-bottom:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(5));
var ContactLinks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__ContactLinks",
  componentId: "sc-m3tb3j-8"
})(["display:flex;flex-direction:column;margin-top:", ";gap:", ";@media (min-width:", "px){flex-direction:row;align-items:center;}"], (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md);
var ContactLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Heroelements__ContactLink",
  componentId: "sc-m3tb3j-9"
})(["cursor:pointer;color:", ";text-decoration:none;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey;
});
var ContactLinkDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__ContactLinkDivider",
  componentId: "sc-m3tb3j-10"
})(["height:", ";width:", ";background:", ";margin:0 ", ";display:none;@media (min-width:", "px){display:block;}"], (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(1), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md);
;// CONCATENATED MODULE: ./src/components/ContactHero/Hero.tsx









var HeroTemplate = function HeroTemplate() {
  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
      src: (0,url_utils/* publicAssets */.VK)('/contact_hero.webp')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Contacts, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Hero_elements_Title, {
        children: t('contact.hero.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Hero_elements_Icon, {
          name: Icon/* Icons.Call */.PJ.Call
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hero_elements_Contact, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactLinks, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactLink, {
              onClick: function onClick() {
                var _window, _window$fbq;

                return (_window = window) === null || _window === void 0 ? void 0 : (_window$fbq = _window.fbq) === null || _window$fbq === void 0 ? void 0 : _window$fbq.call(_window, 'track', constants/* FBQ_EVENTS.CONTACT */.PT.CONTACT);
              },
              href: "tel:".concat(t('contact.service.tel')),
              children: t('contact.orders.tel')
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Hero_elements_Icon, {
          name: Icon/* Icons.Mail */.PJ.Mail
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hero_elements_Contact, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactLinks, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactLink, {
              onClick: function onClick() {
                var _window2, _window2$fbq;

                return (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$fbq = _window2.fbq) === null || _window2$fbq === void 0 ? void 0 : _window2$fbq.call(_window2, 'track', constants/* FBQ_EVENTS.CONTACT */.PT.CONTACT);
              },
              href: "mailto:".concat(t('contact.orders.mail')),
              children: t('contact.orders.mail')
            })
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var Hero = (HeroTemplate);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(57130);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/ui/TeamPerson/TeamPerson.tsx + 1 modules
var TeamPerson = __webpack_require__(30213);
;// CONCATENATED MODULE: ./src/components/Team/Team.elements.tsx


var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Teamelements__Background",
  componentId: "sc-lp5l3t-0"
})(["background:", ";padding:0 ", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.greyLight;
}, (0,polished_esm/* rem */.hO)(40));
var Persons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Teamelements__Persons",
  componentId: "sc-lp5l3t-1"
})(["padding:", " 0 ", " 0;display:grid;grid-template-columns:repeat(auto-fill,minmax(250px,1fr));grid-gap:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(25));
;// CONCATENATED MODULE: ./src/components/Team/Team.tsx









var TEAMS = [{
  image: '/a_zizka.webp',
  name: 'Alexandra Žižka',
  position: 'Manažerka vzdělávání',
  phones: ['+420 739 213 778'],
  mail: 'zizka@pp.cz'
}, {
  image: '/k_hajkova.webp',
  name: 'Kateřina Hájková',
  position: 'Manažerka obchodního rozvoje a strategických partnerství',
  phones: ['+420 737 011 296'],
  mail: 'hajkova@pp.cz'
}, {
  image: '/z_rajchartova.webp',
  name: 'Vanesa Rajchartová',
  position: 'Produktová manažerka – mzdy, pracovní právo, personalistika a veřejná správa',
  phones: ['+420 734 156 851'],
  mail: 'rajchartova@pp.cz'
}, {
  image: '/z_polivkova.jpg',
  name: 'Gabriela Polívková',
  position: 'Produktová manažerka - daně, účetnictví a finance',
  phones: ['+420 602 245 664'],
  mail: 'polivkova@pp.cz'
}, {
  image: '/z_jureckova.webp',
  name: 'Šárka Jurečková',
  position: 'Produktová manažerka - soft skills, firemní kurzy na míru',
  phones: ['+420 602 398 155'],
  mail: 'jureckova@pp.cz'
}, {
  image: '/z_abelova.webp',
  name: 'Veronika Ábelová',
  position: 'Marketingová specialistka',
  phones: ['+420 737 936 574'],
  mail: 'abelova@pp.cz'
}, {
  image: '/z_blahutova.webp',
  name: 'Miluše Blahutová',
  position: 'Manažerka klientských služeb',
  phones: ['+420 212 247 811'],
  mail: 'blahutova@pp.cz'
}, {
  image: '/z_salimova.webp',
  name: 'Elizabeth Salimova',
  position: 'Specialistka klientské péče',
  phones: ['+420 212 247 824'],
  mail: 'salimova@pp.cz'
}];

var TeamTemplate = function TeamTemplate() {
  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  (0,useScrollToSection/* default */.Z)('nas-tym', 'nastym');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    withPadding: true,
    id: "nastym",
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H3 */.Z.H3,
      isBlack: true,
      children: t('contact.team.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Persons, {
      children: TEAMS.map(function (person, personKey) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(TeamPerson/* default */.Z, {
          personKey: personKey,
          image: person.image,
          name: person.name,
          position: person.position,
          phones: person.phones,
          mail: person.mail
        }, personKey);
      })
    })]
  });
};

/* harmony default export */ var Team = (TeamTemplate);
// EXTERNAL MODULE: ./src/ui/Divider/Divider.tsx + 1 modules
var Divider = __webpack_require__(96770);
;// CONCATENATED MODULE: ./src/pages/kontakt.tsx















var kontakt_Contacts = function Contacts() {
  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.contact.title'),
      description: "",
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Hero, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Team, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Address, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactForm/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var kontakt = (kontakt_Contacts);

/***/ }),

/***/ 20644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ contactApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var CONTACT = 'pv/contact';
var LEASE = 'pv/contact/lease-form';
var COMPANY_COURSES_ORDER = 'pv/contact/company-course-form';
var WITHDRAWAL = 'pv/contact/withdrawal';
var contactApi = {
  contact: function contact(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(CONTACT, data);
  },
  contactLease: function contactLease(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(LEASE, data);
  },
  withdrawal: function withdrawal(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(WITHDRAWAL, data);
  },
  companyCoursesOrder: function companyCoursesOrder(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(COMPANY_COURSES_ORDER, data);
  }
};

/***/ }),

/***/ 96770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Divider; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
;// CONCATENATED MODULE: ./src/ui/Divider/Divider.elements.tsx


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Dividerelements__Wrapper",
  componentId: "sc-1b0a3wd-0"
})(["height:1px;width:100%;background:", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, function (prop) {
  return prop.marginTop ? "margin-top: ".concat((0,polished_esm/* rem */.hO)(prop.marginTop)) : '';
}, function (prop) {
  return prop.marginBottom ? "margin-bottom: ".concat((0,polished_esm/* rem */.hO)(prop.marginBottom)) : '';
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Divider/Divider.tsx




var DividerTemplate = function DividerTemplate(_ref) {
  var marginTop = _ref.marginTop,
      marginBottom = _ref.marginBottom;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    marginTop: marginTop,
    marginBottom: marginBottom
  });
};

/* harmony default export */ var Divider = (DividerTemplate);

/***/ }),

/***/ 83297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleTagTypes; },
  "C": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.element.tsx



var TitleStyles = (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";padding:", ";", ";@media (min-width:", "px){", ";padding:", ";font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0");
}, function (prop) {
  return prop.isBlack ? "color: ".concat(prop.theme.colors.black) : "color: ".concat(prop.theme.colors.primary);
}, theme/* breakpoints.sm */.A.sm, function (prop) {
  return prop.alignLeft ? 'text-align: left' : 'text-align: center';
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0 ").concat((0,polished_esm/* rem */.hO)(45), " 0");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h3;
});
var WrapperDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Titleelement__WrapperDiv",
  componentId: "sc-s8z71i-0"
})(["", ""], TitleStyles);
var WrapperH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Titleelement__WrapperH1",
  componentId: "sc-s8z71i-1"
})(["", ""], TitleStyles);
var WrapperH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Titleelement__WrapperH2",
  componentId: "sc-s8z71i-2"
})(["", ""], TitleStyles);
var WrapperH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Titleelement__WrapperH3",
  componentId: "sc-s8z71i-3"
})(["", ""], TitleStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.tsx



var TitleTagTypes;

(function (TitleTagTypes) {
  TitleTagTypes["H1"] = "h1";
  TitleTagTypes["H2"] = "h2";
  TitleTagTypes["H3"] = "h3";
})(TitleTagTypes || (TitleTagTypes = {}));

var TitleTemplate = function TitleTemplate(_ref) {
  var children = _ref.children,
      alignLeft = _ref.alignLeft,
      withoutPadding = _ref.withoutPadding,
      isBlack = _ref.isBlack,
      tagType = _ref.tagType;

  if (tagType === TitleTagTypes.H1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH1, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH3, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH2, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperDiv, {
    withoutPadding: withoutPadding,
    alignLeft: alignLeft,
    isBlack: isBlack,
    children: children
  });
};

/* harmony default export */ var Title = (TitleTemplate);

/***/ }),

/***/ 30213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TeamPerson; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
;// CONCATENATED MODULE: ./src/ui/TeamPerson/TeamPerson.elements.tsx


var Person = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TeamPersonelements__Person",
  componentId: "sc-mlss32-0"
})(["display:flex;flex-direction:column;width:", ";margin:0 ", " ", " ", ";"], (0,polished_esm/* rem */.hO)(250), function (prop) {
  return prop.withoutMargin ? 0 : 'auto';
}, (0,polished_esm/* rem */.hO)(20), function (prop) {
  return prop.withoutMargin ? 0 : 'auto';
});
var PersonDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TeamPersonelements__PersonDetail",
  componentId: "sc-mlss32-1"
})(["background:", ";font-size:", ";padding:", " 0;height:", ";display:flex;flex-direction:column;width:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.textMedium;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(140), function (prop) {
  return prop.width ? (0,polished_esm/* rem */.hO)(prop.width) : '100%';
});
var PersonName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TeamPersonelements__PersonName",
  componentId: "sc-mlss32-2"
})(["font-weight:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
});
var PersonPosition = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TeamPersonelements__PersonPosition",
  componentId: "sc-mlss32-3"
})(["padding:", " 0 ", " 0;height:", ";"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(90));
var PersonPhone = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "TeamPersonelements__PersonPhone",
  componentId: "sc-mlss32-4"
})(["padding-bottom:", ";color:", ";cursor:pointer;text-decoration:none;"], (0,polished_esm/* rem */.hO)(5), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
});
var PersonMail = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "TeamPersonelements__PersonMail",
  componentId: "sc-mlss32-5"
})(["color:", ";cursor:pointer;text-decoration:none;margin-top:auto;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
});
var PersonImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "TeamPersonelements__PersonImage",
  componentId: "sc-mlss32-6"
})(["width:", ";height:auto;border-radius:", ";"], function (prop) {
  return prop.width ? (0,polished_esm/* rem */.hO)(prop.width) : '100%';
}, (0,polished_esm/* rem */.hO)(16));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/TeamPerson/TeamPerson.tsx






var TeamPersonTemplate = function TeamPersonTemplate(_ref) {
  var personKey = _ref.personKey,
      image = _ref.image,
      name = _ref.name,
      position = _ref.position,
      _ref$phones = _ref.phones,
      phones = _ref$phones === void 0 ? [] : _ref$phones,
      mail = _ref.mail,
      width = _ref.width,
      withoutMargin = _ref.withoutMargin;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Person, {
    withoutMargin: withoutMargin,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PersonImage, {
      width: width,
      src: (0,url_utils/* publicAssets */.VK)(image)
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PersonDetail, {
      width: width,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PersonName, {
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PersonPosition, {
        children: position
      }), phones.map(function (phone, phoneKey) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PersonPhone, {
          href: "href:".concat(phone),
          children: phone
        }, phoneKey);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PersonMail, {
        href: "mailto:".concat(mail),
        children: mail
      })]
    })]
  });
};

/* harmony default export */ var TeamPerson = (TeamPersonTemplate);

/***/ }),

/***/ 59421:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kontakt",
      function () {
        return __webpack_require__(82567);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,6506,9774,2888,179], function() { return __webpack_exec__(59421); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);